import { APP_NAME, imageFields, metafieldFields, productFields, productVariantFields } from "../fields";
import {
  collectionFragment,
  mediaImageFragment,
  metaObjectImageFragment,
  metaObjectProductFragment,
  variantMetafields,
} from "../fragments";

export const metaObjectFragment = {
  operation: "Metaobject",
  fields: ["id", { fields: ["key", "value"] }],
  fragment: true,
};

const hiddenName: Record<string, string> = {
  tune: '(namespace: "custom", key: "hidden")',
  yeseyesee: '(namespace: "custom", key: "hidden")',
  thisisneverthat: '(namespace: "operation", key: "hidden")',
  khakis: '(namespace: "operation", key: "hidden")',
  sunlove: '(namespace: "operation", key: "hidden")',
  wellbeingexpress: '(namespace: "operation", key: "hidden")',
};

export const images = {
  operation: "images(first: 50)",
  fields: [{ edges: [{ node: imageFields }] }],
  variables: {},
};

export const hiddenMetafield = {
  operation: {
    name: `metafield${hiddenName[APP_NAME]}`,
    alias: "hidden",
  },
  fields: metafieldFields,
  variables: {},
};

export const employeeOnlyMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "employee_only")',
    alias: "employeeOnly",
  },
  fields: metafieldFields,
  variables: {},
};

export const launchMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "launch")',
    alias: "launch",
  },
  fields: [...metafieldFields, { reference: [metaObjectImageFragment] }],
  variables: {},
};

export const launchesMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "launch")',
    alias: "launches",
  },
  fields: [
    ...metafieldFields,
    {
      reference: [
        {
          operation: "Metaobject",
          fields: ["id", { fields: ["key", "value", "type"] }],
          fragment: true,
        },
      ],
    },
  ],
  variables: {},
};

const quantityName: Record<string, string> = {
  tune: '(namespace: "custom", key: "quantity_limit_variant")',
  yeseyesee: '(namespace: "operation", key: "quantity_limit")',
  thisisneverthat: '(namespace: "operation", key: "quantity_limit")',
  khakis: '(namespace: "operation", key: "quantity_limit")',
  sunlove: '(namespace: "operation", key: "quantity_limit")',
  wellbeingexpress: '(namespace: "operation", key: "quantity_limit")',
};

export const quantityLimitMetafield = {
  operation: {
    name: `metafield${quantityName[APP_NAME]}`,
    alias: "quantityLimit",
  },
  fields: metafieldFields,
  variables: {},
};

const noticeName: Record<string, string> = {
  tune: '(namespace: "notice", key: "content")',
  yeseyesee: '(namespace: "info", key: "notice")',
  thisisneverthat: '(namespace: "notice", key: "content")',
  khakis: '(namespace: "notice", key: "content")',
  sunlove: '(namespace: "info", key: "notice")',
  wellbeingexpress: '(namespace: "info", key: "notice")',
};

export const noticeMetafield = {
  operation: {
    name: `metafield${noticeName[APP_NAME]}`,
    alias: "notice",
  },
  fields: metafieldFields,
  variables: {},
};

const warningName: Record<string, string> = {
  khakis: '(namespace: "warning", key: "content")',
};

export const warningMetafield = {
  operation: {
    name: `metafield${warningName[APP_NAME]}`,
    alias: "warning",
  },
  fields: metafieldFields,
  variables: {},
};

export const informationMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "information")',
    alias: "information",
  },
  fields: metafieldFields,
  variables: {},
};

export const offlineOnlyMessageMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "offline_only_message")',
    alias: "offlineOnlyMessage",
  },
  fields: metafieldFields,
  variables: {},
};

const additionalDescriptionName: Record<string, string> = {
  tune: '(namespace: "additional", key: "description")',
  yeseyesee: '(namespace: "info", key: "additional_description")',
  thisisneverthat: '(namespace: "info", key: "additional_description")',
  khakis: '(namespace: "info", key: "additional_description")',
  sunlove: '(namespace: "info", key: "additional_description")',
  wellbeingexpress: '(namespace: "info", key: "additional_description")',
};

export const additionalDescriptionMetafield = {
  operation: {
    name: `metafield${additionalDescriptionName[APP_NAME]}`,
    alias: "additionalDescription",
  },
  fields: metafieldFields,
  variables: {},
};

const sizeChartName: Record<string, string> = {
  tune: '(namespace: "size", key: "chart")',
  yeseyesee: '(namespace: "info", key: "size_chart")',
  thisisneverthat: '(namespace: "info", key: "size_chart")',
  khakis: '(namespace: "size", key: "chart")',
  sunlove: '(namespace: "info", key: "size_chart")',
  wellbeingexpress: '(namespace: "info", key: "size_chart")',
};

export const sizeChartMetafield = {
  operation: {
    name: `metafield${sizeChartName[APP_NAME]}`,
    alias: "sizeChart",
  },
  fields: metafieldFields,
  variables: {},
};

export const dropDateMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "drop_date")',
    alias: "dropDate",
  },
  fields: metafieldFields,
  variables: {},
};

export const tagMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "tag")',
    alias: "tag",
  },
  fields: metafieldFields,
  variables: {},
};

export const categoryMetafield = {
  operation: {
    name: 'metafield(namespace: "category", key: "sub")',
    alias: "category",
  },
  fields: metafieldFields,
  variables: {},
};

export const productVariantMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "restock_notification")',
    alias: "restock",
  },
  fields: metafieldFields,
  variables: {},
};

export const seungsuStockMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "seongsu_stock")',
    alias: "seoungsu_stock",
  },
  fields: metafieldFields,
  variables: {},
};

export const preorderMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "preorder")',
    alias: "preorder",
  },
  fields: [...metafieldFields, { reference: [metaObjectFragment] }],
  variables: {},
};

const quantityLimitProductName: Record<string, string> = {
  tune: '(namespace: "custom", key: "quantity_limit")',
  yeseyesee: '(namespace: "operation", key: "quantity_limit_product")',
  thisisneverthat: '(namespace: "operation", key: "quantity_limit_product")',
  khakis: '(namespace: "operation", key: "quantity_limit_product")',
  sunlove: '(namespace: "operation", key: "quantity_limit_product")',
  wellbeingexpress: '(namespace: "operation", key: "quantity_limit_product")',
};

export const quantityLimitProductMetafield = {
  operation: {
    name: `metafield${quantityLimitProductName[APP_NAME]}`,
    alias: "quantityLimitProduct",
  },
  fields: metafieldFields,
  variables: {},
};

export const sizeFitMetafield = {
  operation: {
    name: 'metafield(namespace: "size-fit", key: "values")',
    alias: "size_fit",
  },
  fields: metafieldFields,
  variables: {},
};

export const availableCountriesMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "available_countries")',
    alias: "availableCountries",
  },
  fields: metafieldFields,
  variables: {},
};

export const unavailableCountriesMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "unavailable_countries")',
    alias: "unavailableCountries",
  },
  fields: metafieldFields,
  variables: {},
};

export const modelMetafield = {
  operation: {
    name: 'metafield(namespace: "model", key: "size")',
    alias: "model",
  },
  fields: metafieldFields,
  variables: {},
};

export const maleModelMetafield = {
  operation: {
    name: 'metafield(namespace: "model", key: "info")',
    alias: "maleModel",
  },
  fields: metafieldFields,
  variables: {},
};

export const femaleModelMetafield = {
  operation: {
    name: 'metafield(namespace: "model", key: "info2")',
    alias: "femaleModel",
  },
  fields: metafieldFields,
  variables: {},
};

export const modelInfoMetafield = {
  operation: {
    name: 'metafield(namespace: "model", key: "info")',
    alias: "modelInformation",
  },
  fields: metafieldFields,
  variables: {},
};

export const modelInformationMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "model_information")',
    alias: "modelInformation",
  },
  fields: metafieldFields,
  variables: {},
};

export const relatedCollectionMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "related_collection")',
    alias: "related_collection",
  },
  fields: [
    {
      operation: "references(first: 10)",
      fields: [{ edges: [{ node: [collectionFragment] }] }],
      variables: {},
    },
  ],
  variables: {},
};

export const releaseDateMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "release_date")',
    alias: "release_date",
  },
  fields: metafieldFields,
  variables: {},
};

export const thumbnailImagesMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "thumbnail_images")',
    alias: "thumbnailImages",
  },
  fields: [
    ...metafieldFields,
    { reference: [mediaImageFragment] },
    {
      operation: "references(first: 10)",
      fields: [{ edges: [{ node: [mediaImageFragment] }] }],
      variables: {},
    },
  ],
  variables: {},
};

export const recommendedStyleMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "recommended_style")',
    alias: "recommended_style",
  },
  fields: [...metafieldFields, { reference: [metaObjectImageFragment, metaObjectProductFragment] }],
  variables: {},
};

export const styleWithProductsMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "style_with_products")',
    alias: "styleWithProducts",
  },
  fields: [
    ...metafieldFields,
    {
      operation: "references(first: 10)",
      fields: [
        {
          edges: [
            {
              node: [
                {
                  operation: "Product",
                  fields: [
                    ...productFields,
                    thumbnailImagesMetafield,
                    images,
                    {
                      operation: "variants(first: 10)",
                      fields: [
                        {
                          edges: [{ node: [...productVariantFields, ...variantMetafields[APP_NAME]] }],
                        },
                      ],
                      variables: {},
                    },
                  ],
                  fragment: true,
                },
              ],
            },
          ],
        },
      ],
      variables: {},
    },
  ],
  variables: {},
};

export const membershipMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "accessible_memberships")',
    alias: "accessible_memberships",
  },
  fields: metafieldFields,
  variables: {},
};

export const brandVariantIdMetafield = {
  operation: {
    name: 'metafield(namespace: "familysale", key: "brand_variant_id")',
    alias: "brandVariantId",
  },
  fields: metafieldFields,
  variables: {},
};

export const saleMetafield = {
  operation: {
    name: 'metafield(namespace: "familysale", key: "sale")',
    alias: "sale",
  },
  fields: metafieldFields,
  variables: {},
};

export const featureMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "feature")',
    alias: "feature",
  },
  fields: metafieldFields,
  variables: {},
};

export const materialsMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "materials")',
    alias: "materials",
  },
  fields: metafieldFields,
  variables: {},
};

export const brandNameMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "brand_name")',
    alias: "brandName",
  },
  fields: metafieldFields,
  variables: {},
};

export const dominantColorMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "dominant_color")',
    alias: "dominantColor",
  },
  fields: metafieldFields,
  variables: {},
};

export const hoverImageMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "hover_image")',
    alias: "hoverImage",
  },
  fields: [...metafieldFields, { reference: [mediaImageFragment] }],
  variables: {},
};

export const discountCodeAvailabilityMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "discount_code_availability")',
    alias: "discountCodeAvailability",
  },
  fields: metafieldFields,
  variables: {},
};

export const membershipAutoDiscountMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "membership_auto_discount")',
    alias: "membershipAutoDiscount",
  },
  fields: metafieldFields,
  variables: {},
};

export const colorMetafield = {
  operation: {
    name: 'metafield(namespace: "filter", key: "color")',
    alias: "color",
  },
  fields: metafieldFields,
  variables: {},
};
